package com.example.readingnotes.data.remote.dto

import kotlinx.serialization.Serializable

@Serializable
data class CommentDto(
    val id: String, // UUID
    val postId: String, // UUID
    val tenantId: String? = null, // UUID
    val authorName: String,
    val content: String,
    val createdAt: String,
)

@Serializable
data class CreateCommentRequestDto(
    val authorName: String?,
    val content: String,
)
